/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type SignatureProvider = typeof SignatureProvider[keyof typeof SignatureProvider];


export const SignatureProvider = {
  docusign: 'docusign',
  adobe_sign: 'adobe_sign',
  internal: 'internal',
} as const;
